<template>
  <div class="express">
    <h3>一线快递商家版</h3>
    <div class="content">
      <div class="left">
        <el-form :model="info" ref="info" :rules="rules" label-width="110px" class="demo-ruleForm">
          <el-form-item
            label="所在城市："
            prop="address"
          >
            <div class="city">
              <area-city @city="city" />
            </div>
          </el-form-item>
          <el-form-item
            label="详细地址："
            prop="address"
          >
            <el-input v-model="info.address"></el-input>
          </el-form-item>
          <el-form-item
            label="商户名称："
            prop="businessName"
          >
            <el-input v-model="info.businessName"></el-input>
          </el-form-item>
          <el-form-item
            label="商户联系人："
            prop="businessContacter"
          >
            <el-input v-model="info.businessContacter"></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话："
            prop="businessPhone"
          >
            <el-input v-model="info.businessPhone"></el-input>
          </el-form-item>
          <el-form-item
            label="经营类型："
            prop="businessType"
          >
            <el-select placeholder="请选择" v-model="info.businessType">
              <el-option :label="item" :value="item" v-for="item in manageList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="日单量："
            prop="dailyCount"
          >
            <el-input v-model="info.dailyCount"></el-input>
          </el-form-item>
          <el-form-item
            label="客单价："
            prop="avgPrice"
          >
            <el-input v-model="info.avgPrice"></el-input>
          </el-form-item>
          <el-form-item
            label="销售平台："
            prop="salesPlatform"
          >
            <el-select placeholder="请选择" v-model="info.salesPlatform">
              <el-option :label="item" :value="item" v-for="item in sellList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="put" type="primary" @click="submitForm('info')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <p>上传店铺营业执照照片：</p>
        <div class="img">
          <img :src="avatar" alt="">
          <div class="claim">
            <p>要求：</p>
            <p>1、清晰</p>
            <p>2、真实</p>
          </div>
        </div>
        <label for="file">
          <span>本地上传</span>
        </label>
        <input type="file" id="file"  @change="changeImage($event)" accept="image/gif,image/jpeg,image/jpg,image/png">
      </div>
    </div>
  </div>
</template>

<script>
import {reqMerchant, reqMerchantUpgrade, reqFileUpload} from '../../../api'
import {mobiles} from '../../../utils/phone'
import AreaCity from '../../../components/AreaCity'
import {mapState} from 'vuex'
export default {
  data() {
    let validPhone = (rule, value, callback) => {
      if(!mobiles(value)){
        callback(new Error('手机号码不正确'))
      }else{
        callback()
      }
    }
    return {
      info: {
        city: '', // 地址
        address: '', // 详细地址
        businessName: '', // 商户名称
        businessContacter: '', // 商户联系人
        businessPhone: '', // 电话
        businessType: '', // 经营类型
        dailyCount: '', // 日单量
        avgPrice: '', // 客单价
        salesPlatform: '', // 销售平台
        idCardImgUuid: '', // 营业执照图片id
      },
      avatar: '', // 头像
      manageList:[], // 经营列表
      sellList: [], // 销售列表
      rules:{
        city: [{required: true, message: '请选择地址', trigger: 'blur'}],
        address: [{required: true, message: '请填写详细地址', trigger: 'blur'}],
        businessName: [{required: true, message: '请输入商户名称', trigger: 'blur'}],
        businessContacter: [{required: true, message: '请输入商户联系人', trigger: 'blur'}],
        businessPhone: [{required: true, message: '请输入联系电话', trigger: 'blur'}, {validator: validPhone, trigger: 'blur'}],
        businessType: [{required: true, message: '请选择经营类型', trigger: 'blur'}],
        dailyCount: [{required: true, message: '请填写日单量', trigger: 'blur'}],
        avgPrice: [{required: true, message: '请填写客单价', trigger: 'blur'}],
        salesPlatform: [{required: true, message: '请选择销售平台', trigger: 'blur'}],
      }
    }
  },
  created () {
    // 获取注册商家选项
    reqMerchant().then(res => {
      if(res.code === 200){
        this.manageList = (res.data.bussData.businessTypes)[0].split(/\n/)
        this.sellList = (res.data.bussData.salesPlatforms)[0].split(/\n/)
      }
    })
  },
  methods: {
    // 获取地址
    city(city) {
      this.info.city = city
    },
    // 提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.info.idCardImgUuid) {
            this.$message({
              message: '请上传店铺营业执照照片',
              type: 'error'
            })
          } else {
            const {city, address, businessName, businessContacter, businessPhone, businessType, dailyCount, avgPrice, salesPlatform, idCardImgUuid} = this.info
            let addr = ''
            city.forEach(item => {
              addr += item
            })
            let body = {
              city: addr,
              address,
              businessName,
              businessContacter,
              businessPhone,
              businessType,
              dailyCount,
              avgPrice,
              salesPlatform,
              idCardImgUuid
            }
            reqMerchantUpgrade(body).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                this.info.city = ''
                this.info.address = ''
                this.info.businessName = ''
                this.info.businessContacter = ''
                this.info.businessPhone = ''
                this.info.businessType = ''
                this.info.dailyCount = ''
                this.info.avgPrice = ''
                this.info.salesPlatform = ''
                this.info.idCardImgUuid = ''
                this.avatar = ''
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 上传图片
    changeImage (e) {
      let file = e.target.files[0]
      if (file) {
        if (e.srcElement.accept.includes(file.type)) {
          const formData = new FormData()
          formData.append('file', file)
          this.avatar = window.URL.createObjectURL(e.srcElement.files.item(0))
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          reqFileUpload(formData).then(res => {
            if(res.code == 200) {
              this.$message({
                message: res.desc,
                type: 'success'
              })
              this.info.idCardImgUuid = res.result
            }
          })
        } else {
          this.$message({
            message: '图片格式不正确',
            type: 'error'
          })
        }
      }
    },
  },
  computed: {
    ...mapState(['userBaseInfo'])
  },
  components: {
    AreaCity
  }
}
</script>

<style scoped lang="less" type="text/less">
  .express{
    h3{
      font-size: 24px;
      margin-top:60px;
    }
    .content{
      display: flex;
      margin-top:40px;
      .left{
        margin-right: 100px;
        .city{
          width: 340px;
        }
        .put{
          width: 332px;
          height: 48px;
          margin-top:20px;
          border:none;
          background: #61aee6;
          box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
          border-radius:24px;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }
      }
      .right{
        .img{
          display: flex;
          margin-top:21px;
          img{
            display: block;
            width: 150px;
            height: 150px;
            margin-right: 20px;
            background: #ccc;
          }
          .claim{
            p{
              margin-bottom: 21px;
            }
          }
        }
        label{
          span{
            display: block;
            width: 100px;
            height: 40px;
            margin:18px 0 0 25px;
            font-size: 16px;
            font-weight: 500;
            line-height: 40px;
            text-align: center;
            border:1px solid #999;
            border-radius: 20px;
            cursor: pointer;
          }
        }
        input[type='file']{
          display: none;
        }
      }
    }
    .el-input{
      width: 340px;
    }
    .el-select {
      width: 340px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Express.vue